
$(document).ready(function() {
    
    var $body = $('body'),
        $desktopNavItems = $('.header-desktop__menu-item'),
        desktopNavOpenClass = 'header-desktop__menu-item--open';

    // Toggle desktop menu dropdowns
    $(document).on('click', '.header-desktop__menu-link', function(e) {
        e.preventDefault();

        var navItem = $(this).parent();
        
        // Needs to open
        if(navItem.hasClass(desktopNavOpenClass)) {
            navItem.removeClass(desktopNavOpenClass);
        }

        // Needs to close
        else {
            // Close any other open menus first
            $desktopNavItems.filter('.' + desktopNavOpenClass).find('.header-desktop__menu-link').trigger('click');

            navItem.addClass(desktopNavOpenClass);
        }
    });

    // Toggle active class on body when courses menu is opened
    $(document).on('click', '.header-desktop__menu-item--courses .header-desktop__menu-link', function(e) {
        e.preventDefault();

        $body.toggleClass('courses-menu-open');
    });
});